import { Component, OnInit, ElementRef } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GurdServiceService } from "src/app/Service/gurd-service.service";
import { NotificationService } from "src/app/Service/notification.service";
import { OtherService } from "src/app/Service/other.service";
import axios from "src/app/Service/axios";

@Component({

  selector: 'changePass',

  templateUrl: './changePass.component.html',
  styleUrls: ['./changePass.component.css'],

})

export class ChangePassComponent implements OnInit {

  constructor(

    private el: ElementRef,

    private router: Router,

    private route: ActivatedRoute,

    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private notifyService: NotificationService

  ) { }

  password: boolean = false;

  password2: boolean = false;

  password3: boolean = false;

  ForceChangePass: boolean = false;

  ChangePassModel = new FormGroup({

    strPassword: new FormControl(),

    strPassword2: new FormControl(),

    strPasswordNew: new FormControl(),

    Id: new FormControl(),

    strUserName: new FormControl(),

  });

  ngOnInit(): void {

    this.route.url.subscribe(url => {

      if (url[0].path == 'update-password') {

        this.ForceChangePass = true;

        window.localStorage.setItem('ForceChangePass', this.gurdService.encrypt('true'));

        history.pushState(null, '', location.href);

        window.onpopstate = () => {

          history.pushState(null, '', location.href);

          alert('برای ادامه استفاده از سیستم باید رمز عبور خود را تغییر دهید.');

        };

      }

    });

  }

  ngOnDestroy() {

    window.onpopstate = null;

  }


  changeType() {
    this.password = !this.password;
  }

  changeType2() {
    this.password2 = !this.password2;
  }

  changeType3() {
    this.password3 = !this.password3;
  }

  changePass = async () => {

    this.ChangePassModel.controls['Id'].setValue(`${this.gurdService.decrypt(window.localStorage.getItem("ID")!)}`);

    this.ChangePassModel.controls['strUserName'].setValue(`${this.gurdService.decrypt(window.localStorage.getItem("UserName")!)}`);

    var model = this.ChangePassModel.value;

    if (model.strPassword == null || model.strPassword == '' || model.strPasswordNew == null || model.strPasswordNew == '') {

      this.notifyService.showError('لطفا رمز عبور را  وارد کنید');

      return;

    }

    if (model.strPassword2 != model.strPasswordNew) {

      this.notifyService.showError('رمز عبور با تکرارش برابر نیست');

      return;

    }

    this.otherService.Showspinner()

    const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));

    const resp = await axios.post(`ChangePassword4Radyab?strSession=${session}`, model);

    this.otherService.nonespinner()

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      // this.router.navigate(['login']);

      this.router.navigate(['login'], { queryParams: { error: '16' } });

      return;

    }

    if (resp.data.Result == 1) {

      if (this.ForceChangePass) {

        this.notifyService.showSuccess("با موفقیت تغییر کرد");

        window.localStorage.removeItem('ForceChangePass');

        window.onpopstate = null;

        this.router.navigate(['/']);

        return;

      }

      else {

        this.notifyService.showSuccess("با موفقیت تغییر کرد");

        this.otherService.removeLocalStorage();

        this.router.navigate(['/']);

        return;

      }

    }

    if (resp.data.Result == 0) {

      this.notifyService.showError(resp.data.Message);

      return;

    }


  }

}
